import React from 'react';

function SocialIcon(props) {
    const {link, label} = props;
    return (
        <a target="_blank" aria-label={label}
           rel="noopener noreferrer" href={link}>
            <i className="fa fa-instagram" aria-hidden="true" style={{colo:"#000"}}/>
        </a>
    );
}

export default SocialIcon;